module.exports = __webpack_public_path__ + "fonts/work-sans-v4-latin-ext-900.a6b90a10.woff";